import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-anc-model',
  templateUrl: './anc-model.component.html',
  styleUrls: ['./anc-model.component.css'],
})
export class AncModelComponent implements OnInit {
    @Input() benID:any
    @Input() AlraedyDataAdded:any
    
  ancForm: FormGroup;
  gravidaList: any[] = [];
  ttList: any[] = [];
  highriskList: any[] = [];

  trimesterOptions = ['1st Trimester', '2nd Trimester', '3rd Trimester'];
  referredist: any;
  enableOtherGravida: boolean = false;
  enableOtherReason: boolean= false;
  enableHighRiskReason: boolean= false;
  forPrescritionData: any;
  max_date = new Date();
  last_max_date : any


  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private datePipe : DatePipe
  ) {}

  ngOnInit(): void {
    this.last_max_date = new Date();
this.last_max_date.setFullYear(
  this.last_max_date.getFullYear() + 1
);
console.log('last_max_date', this.last_max_date);
    this.getGravida();
    this.getTTGiven();
    this.getHighrisk();
    this.getReferred();
    this.formInIt();
    // this.ancForm.get('referralNeeded')?.valueChanges.subscribe((value) => {
    //   const referredToControl = this.ancForm.get('referredTo');
    //   if (value === true) {
    //     referredToControl?.enable();
    //   } else {
    //     referredToControl?.reset();
    //     referredToControl?.disable();
    //   }
    // });

    if(this.AlraedyDataAdded){
  setTimeout(() => {
    this.ancForm.patchValue(this.AlraedyDataAdded)
    this.isOtherSelected(this.AlraedyDataAdded.gravida_para_id)
    this.isOtherSelectedReason(this.AlraedyDataAdded.highrisk_reason_id)
    this.highriskPregenancy(this.AlraedyDataAdded.high_risk_pregnancy)
  }, 500);
  }
}

  formInIt() {
    this.ancForm = this.fb.group({
      gravida_para_id: [],
      // gravidaOther: [],
      pregnancy_trimester: [],
      if_given: [false],
      tt_injection_given_id: [],
      high_risk_pregnancy: [false],
      highrisk_reason_id: [],
      if_others_highrisk_reason: [],
      consult_refer_to_id: [],
      beneficiary_id: this.benID,
      lmp_date :[new Date()],
      edd_date : [new Date()]
    });
  }

  isOtherSelected(value:any) {
    if(value == '4'){
      this.enableOtherGravida =true
      // this.ancForm.get('gravida_para_id')?.setValue(null);
    }else{
       this.enableOtherGravida =false
      this.ancForm.get('gravidaOther')?.setValue(null);
    }
   
  }
  isOtherSelectedReason(value:any) {
    if(value == '6'){
      this.enableOtherReason =true
      // this.ancForm.get('highrisk_reason_id')?.setValue(null);
    }else{
       this.enableOtherReason =false
      this.ancForm.get('if_others_highrisk_reason')?.setValue(null);
    }
   
  }
  highriskPregenancy(value:any){
    if(value == false){
      this.enableHighRiskReason = false
      this.enableOtherReason =false
      this.ancForm.get('if_others_highrisk_reason')?.setValue(null);
      this.ancForm.get('highrisk_reason_id')?.setValue(null);
    }else{
      this.enableHighRiskReason = true
    }

  }

  getGravida() {
    this.regService.get(`masters/masters/getallgravidapara`).subscribe({
        next: (res) => {
          if (res.status == 'OK') {
            this.gravidaList = res.data ?? [];
            this.toastr.success(res.message);
          } else {
            let errMsg: string = res.message;
            this.toastr.error(errMsg);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
        },
        complete: () => {
          // Any additional logic after patching values
        },
      });
  }

  getTTGiven() {
    this.regService.get(`masters/masters/getallttinjectiontypes`).subscribe({
        next: (res) => {
          if (res.status == 'OK') {
            this.ttList = res.data ?? [];
            this.toastr.success(res.message);
          } else {
            let errMsg: string = res.message;
            this.toastr.error(errMsg);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
        },
        complete: () => {
          // Any additional logic after patching values
        },
      });
  }
  getHighrisk() {
    this.regService.get(`masters/masters/getallhighriskreason`).subscribe({
        next: (res) => {
          if (res.status == 'OK') {
            this.highriskList = res.data ?? [];
            this.toastr.success(res.message);
          } else {
            let errMsg: string = res.message;
            this.toastr.error(errMsg);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message);
        },
        complete: () => {
          // Any additional logic after patching values
        },
      });
  }

   getReferred() {
    this.regService.get(`masters/masters/getallreferredto`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.referredist = res.data ?? [];
          this.toastr.success(res.message);
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

  onSave(){
    this.forPrescription();
    this.toastr.success("Records Saved After POC Submition")
    let data={
      "ancForm" : this.ancForm ,
      "forPrescritionData" : this.forPrescritionData
    }
    setTimeout(() => {
      console.log('ANC Data',data)
      this.activeModal.close(data)
    }, 200);
   
  }

  forPrescription(){
    this.forPrescritionData={
      gravida_para_id: this.gravidaList.find( (e: any) => e.id == this.ancForm.value.gravida_para_id)?.name || '',
      pregnancy_trimester: this.ancForm.value.pregnancy_trimester || null,
      if_given: this.ancForm.value.if_given || false,
      tt_injection_given_id: this.ttList.find( (e: any) => e.id == this.ancForm.value.tt_injection_given_id)?.name || '',
      high_risk_pregnancy: this.ancForm.value.high_risk_pregnancy || false,
      highrisk_reason_id: this.highriskList.find( (e: any) => e.id == this.ancForm.value.highrisk_reason_id)?.name || '',
      if_others_highrisk_reason: this.ancForm.value.if_others_highrisk_reason,
      consult_refer_to_id: [],
      beneficiary_id: this.benID,
      lmp_date : this.datePipe.transform(this.ancForm.value.lmp_date,'yyyy-MM-dd'),
      edd_date : this.datePipe.transform(this.ancForm.value.edd_date,'yyyy-MM-dd')
      
    }

    // Check all relevant values
     const isPrescrEmpty = Object.entries(this.forPrescritionData).filter(([key, value]) =>
      key !== 'beneficiary_id' && !(key.endsWith('_id') && value === 0) )
      .every(([_, value]) => value === null || value === '' || value === undefined);

       if (isPrescrEmpty) {
         this.forPrescritionData = null;
      }

  }

  
}
